/**
 * Helpers for SPA location updates that stay on the same page
 * (hash-only changes, or history pushState/popstate with the same path).
 *
 * Seatics' mobile quantity drawer often adds a history entry (hash or
 * pushState) so the system Back gesture can close it. React Router still
 * sees a new `location` object and would otherwise refetch listing data
 * and scroll-to-top — which looks like a full page reload and can flash
 * the drawer closed on the first tap.
 */

export const isSamePathAndSearch = (prev, next) => {
  if (!prev || !next) return false;
  return prev.pathname === next.pathname && prev.search === next.search;
};

export const hashTargetId = hash => {
  if (hash == null) return null;
  const raw = String(hash);
  if (!raw || raw === '#') return null;
  const id = raw.charAt(0) === '#' ? raw.slice(1) : raw;
  if (!id) return null;
  try {
    return decodeURIComponent(id);
  } catch (e) {
    return id;
  }
};

/** Resolve an in-page hash without using querySelector('#') (invalid CSS). */
export const findHashTargetElement = (hash, doc = typeof document !== 'undefined' ? document : null) => {
  const id = hashTargetId(hash);
  if (!id || !doc || typeof doc.getElementById !== 'function') return null;
  return doc.getElementById(id) || null;
};
